import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ResultSection from './ResultSection';
import { t } from '../../services/i18nService';
import scrollingService from '../../services/ScrollingService';
import viewReadyTracker from '../../services/ViewReadyTracker';

import styles from '../tableOfContents/tableOfContents.scss';

export class ResultPage extends React.Component {
    static propTypes = {
        assessment: PropTypes.object.isRequired,
        onReady: PropTypes.func,
        result: PropTypes.object.isRequired,
        settings: PropTypes.object.isRequired,
        ui: PropTypes.object,
        deliveryDetails: PropTypes.object,
    };

    componentDidMount() {
        // This component can be used as a main view or as a sub component, so we need two ways of handling ready reporting.
        if (this.props.onReady) {
            this.props.onReady(true);
        } else {
            viewReadyTracker.getReporter()(true);
        }
        scrollingService.scrollToTop();
    }

    getSections = () => {
        const { assessment, result, settings, ui, deliveryDetails } = this.props;
        const { sections } = assessment;

        return sections.map((section, sectionIndex) => {
            const { questions } = section;

            return (<ResultSection
                questions={questions}
                key={section.id}
                result={result}
                section={section}
                sectionIndex={sectionIndex}
                settings={settings}
                ui={ui}
                deliveryDetails={deliveryDetails}
            />);
        });
    };

    render() {
        const { settings } = this.props;
        const settingsBarStyle = settings.settingsBar && settings.settingsBar.active ? { marginTop: '3.5em' } : null;
        const sections = this.getSections();
        const styleNames = `${styles.body} ${styles.resultBody}`;

        return (
            <div className={styles.resultOverview} role="main" style={settingsBarStyle}>
                <h3 className="sr-only">{t('testOverview.srOnly.questionListHeader')}</h3>
                <table className={styleNames}>
                    {
                        sections || null
                    }
                </table>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { assessment, result, settings, ui, deliveryDetails } = state;

    return {
        assessment,
        result,
        settings,
        ui,
        deliveryDetails,
    };
}

const ResultPageContainer = connect(mapStateToProps)(ResultPage);

export default ResultPageContainer;
